// extracted by mini-css-extract-plugin
module.exports = {"fallback":"antd-pro-layouts-root-layout-index-fallback","eventId":"antd-pro-layouts-root-layout-index-eventId","mt20":"antd-pro-layouts-root-layout-index-mt20"};